import Vue from 'vue';
import path from 'path';
import { CUSTOM_DIVIDER } from '@/constants';

export default Vue.component('section-custom-divider', {
  template: require('./template.html'),
  name: 'section-custom-divider',
  props: ['shape-data'],
  computed: {
    customImage() {
      return this.shapeData.customFile || CUSTOM_DIVIDER;
    },
    alt() {
      return path.basename(this.customImage);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/shape-dividers/custom/index.js